import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';
import type { WithTokenParams } from '#src/app/shared/types/payment';

import { updatePaymentMethod } from '../../api/updatePaymentMethod';

type Result = ModelHookResult<
	undefined,
	{
		withToken: (params: WithTokenParams) => Promise<void>;
	}
>;

export function useWithToken(): Result {
	const utilityContext = useUtilityContext();
	const [, mutations] = useContributionsPageState();
	const { translate } = useI18n();
	const track = useTracking();

	const withToken = async () => {
		void track('sponsor_cc_update_submit_valid');
		const result = await updatePaymentMethod(utilityContext);
		if (result.success) {
			void track('sponsor_cc_update_payment_method_saved');
			void track('sponsor_cc_update_modal_success');

			mutations.handlePaymentUpdateSuccess({
				paymentMethod: result.paymentMethod,
				message: translate('fe.components.payments.update_success'),
			});
		} else {
			void track('sponsor_cc_update_general_error');
			mutations.handlePaymentUpdateError({
				message: translate('fe.errors.generic_try_again'),
			});
		}
	};

	return {
		actions: {
			withToken,
		},
	};
}
